import React from 'react';
import {
    Modal, ModalHeader, ModalBody, ModalFooter, Button,
    Form, FormGroup, Label, Input, InputGroup, InputGroupText
} from 'reactstrap';
import CashSourceListing from './CashSourceListing';
import { constantsCashSources } from '../../../../utils/constants';



class TransferCashSourceModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState;
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    initialState = {
        toSource: constantsCashSources.CASH,
        value: 0,
        fromSource: constantsCashSources.CASH,
        note: ''
    };

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }

    transferCashSource(e) {
        e.preventDefault();
        if (e.target.checkValidity()) {
            this.props.handleSubmit(this.state);
            this.setState(this.initialState);
        }
    }

    render() {
        let { cashSources, open, toggle } = this.props;
        let { toSource, value, note, fromSource } = this.state;
        return (
            <>
                <Modal scrollable isOpen={open} fade={false} toggle={toggle}>
                    <ModalHeader toggle={toggle}>Chuyển Tiền</ModalHeader>
                    <ModalBody>
                        <div class="row">
                            <div class="col-md-12">
                                <Form onSubmit={(e) => this.transferCashSource(e)}>
                                    <FormGroup>
                                        <Label for="toSource">Tên</Label>
                                        <Input onChange={this.handleInputChange} value={toSource} type="select" required name="toSource" id="toSource">
                                            {cashSources && cashSources.map((cs) => (
                                                <option value={cs.name}>{cs.name}</option>
                                            ))}
                                        </Input>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="value">Giá Trị</Label>
                                        <InputGroup>
                                            <Input onChange={this.handleInputChange} value={value} type="number" id="value" name="value" />
                                            <InputGroupText>đ</InputGroupText>
                                        </InputGroup>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="fromSource">Nguồn</Label>
                                        <Input onChange={this.handleInputChange} value={fromSource} type="select" required name="fromSource" id="fromSource">
                                            {cashSources && cashSources.map((cs) => (
                                                <option value={cs.name}>{cs.name}</option>
                                            ))}
                                            <option value="Profit">Lãi/Lỗ</option>
                                            <option value="Other">Khác</option>
                                        </Input>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="note">Ghi Chú</Label>
                                        <Input onChange={this.handleInputChange} value={note} type="textarea" name="note" id="note" />
                                    </FormGroup>
                                    <Button className='mb-2 me-2' type="submit">Chuyển</Button>
                                </Form>
                            </div>
                            <div class="col-md-12">
                                <CashSourceListing cashSources={cashSources} />
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            </>
        );
    }
}

export default TransferCashSourceModal;